import { useMemo } from "react";
import { OverviewHexagon } from "@/components/navigator/OverviewHexagon";
import { useEntities } from "@/contexts/entities/EntitiesContext";
import { LearnerOutcome, Competency } from "@/lib/models";
import { mapPositions } from "@/lib/static/mapPositions";

type OverviewMapProps = {
  selectedEntity: Competency | LearnerOutcome | null;
  handleEntityClick: (entity: Competency | LearnerOutcome) => void;
  searchResultIds: string[];
};

export const OverviewMap = ({
  handleEntityClick,
  selectedEntity,
  searchResultIds,
}: OverviewMapProps) => {
  const { getEntityHierarchyFromId } = useEntities();
  const hydratedMap = useMemo(
    () =>
      mapPositions.map((mapRow) =>
        mapRow.map((id) => {
          const hierarchy = getEntityHierarchyFromId(id);
          return hierarchy.competency || hierarchy.learnerOutcome!;
        }),
      ),
    [getEntityHierarchyFromId],
  );

  const topOffsets = [
    "top-0",
    "top-[106px]",
    "top-[212px]",
    "top-[318px]",
    "top-[424px]",
    "top-[530px]",
    "top-[636px]",
    "top-[742px]",
  ];

  const leftOffsets = [
    "left-[244px]",
    "left-[61px]",
    "left-0",
    "left-[61px]",
    "left-[122px]",
    "left-[183px]",
    "left-[244px]",
    "left-[427px]",
  ];

  return (
    <div className="col-span-full mx-auto mb-[60px] min-w-[980px]">
      <div className="relative h-[880px] w-full">
        {hydratedMap.map((mapRow, index1) => {
          return (
            <div
              key={index1}
              className={`absolute flex w-fit justify-center ${topOffsets[index1]} ${leftOffsets[index1]}`}
            >
              {mapRow.map((entity, index2) => {
                return (
                  <OverviewHexagon
                    entity={entity}
                    key={`${index1},${index2}`}
                    handleHexagonClick={handleEntityClick}
                    selectedEntity={selectedEntity}
                    searchResultIds={searchResultIds}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};
